// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const emptyArray: readonly any[] = Object.freeze([]);
